import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";

import SoftBox from "components/SoftBox";
import Breadcrumbs from "cxfcomponents/Breadcrumbs";
import { useSoftUIController, setMiniSidenav } from "context";
import { THEME_COLORS } from "constants/theme";
import { MINI_SIDENAV_WIDTH, PORTAL_HEADER_HEIGHT, SIDENAV_WIDTH } from "cxfcomponents/portalShell";
import { ThemedMaximizeIcon } from "assets/CXFIcons/Designer/Toolbox";
import SettingsMenu from "./components/SettingsMenu";
import "./style.css";

function DashboardNavbar({ light = false, title }) {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav } = controller;
  const route = useLocation().pathname.split("/").slice(1);
  const sidebarWidth = miniSidenav ? MINI_SIDENAV_WIDTH : SIDENAV_WIDTH;

  return (
    <AppBar
      position="fixed"
      color="inherit"
      sx={(theme) => ({
        top: 0,
        left: 0,
        right: 0,
        width: "auto !important",
        height: PORTAL_HEADER_HEIGHT,
        minHeight: PORTAL_HEADER_HEIGHT,
        padding: "0 !important",
        margin: 0,
        borderRadius: 0,
        borderBottom: "1px solid rgba(140, 150, 170, 0.2)",
        boxShadow: "none",
        backdropFilter: "none",
        backgroundColor: `${theme.palette.mode === "dark" ? THEME_COLORS.DARK.NAVBAR_BG : THEME_COLORS.LIGHT.NAVBAR_BG} !important`,
        zIndex: 1100,
        [theme.breakpoints.up("xl")]: {
          left: sidebarWidth,
        },
      })}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          minHeight: `${PORTAL_HEADER_HEIGHT}px !important`,
          height: PORTAL_HEADER_HEIGHT,
          padding: { xs: "0 12px !important", sm: "0 24px !important" },
        }}
      >
        <SoftBox sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
          {miniSidenav && (
            <IconButton
              aria-label="Maximize sidebar"
              title="Maximize sidebar"
              onClick={() => setMiniSidenav(dispatch, false)}
              sx={(theme) => ({
                display: { xs: "none", xl: "flex" },
                width: 32,
                height: 32,
                mr: 1,
                color: theme.palette.mode === "dark" ? "#aa8bfd" : "#7443ff",
              })}
            >
              <ThemedMaximizeIcon />
            </IconButton>
          )}
          <Breadcrumbs icon="home" title={title ?? route[route.length - 1]} route={route} light={light} />
        </SoftBox>
        <SoftBox color={light ? "white" : "inherit"}>
          <SettingsMenu />
        </SoftBox>
      </Toolbar>
    </AppBar>
  );
}

DashboardNavbar.propTypes = {
  light: PropTypes.bool,
  title: PropTypes.string,
};

export default DashboardNavbar;
